import { useParams, useSearchParams } from 'react-router-dom';
import { useGetUserDataQuery } from '../../auth/api/authApi';
import { PricingSection } from '../components/PricingSection';
import { useSelector } from 'react-redux';
import { authSelector } from '../../auth/state/authSlice';
import styled from 'styled-components';
import { LocationsOptions } from '../../dashboard/pages/activate';

export const Pricing = () => {
  const { iccid, customerId } = useParams<{ iccid: string; customerId: string }>();
  const { token } = useSelector(authSelector);
  const { data } = useGetUserDataQuery({ token: token || '' });
  const [searchParams] = useSearchParams();

  const location = searchParams.get('location') as LocationsOptions;

  const userLocation = location || 'uk';

  const userEmail = data?.data.email;

  if (!userEmail || !iccid) {
    return <div>Loading...</div>;
  }

  return (
    <Container>
      <PricingSection
        location={userLocation}
        customerId={customerId}
        reactivation
        email={userEmail}
        iccid={iccid}
        title="No active subscription associated with SIM."
        description="If you believe this is an error and payments have been deducted from your account, please forward your latest invoice to support@farmstream.co.uk. Otherwise, please resubscribe to avoid SIM termination at the end of the month. This could be a result of an expired card or insufficient balance."
      />
    </Container>
  );
};

const Container = styled.div`
  padding: 0 1rem;
  width: 100%;
  height: 90vh;
  overflow-y: auto;
`;
